import { Controller } from 'stimulus';
import Choices from 'choices.js';

export default class extends Controller {

  initIntialSelection = false;

  connect() {
    let element = this.element;

    let dataset = element.dataset;
    this.multiple = element.multiple;
    this.searchEnabled == dataset.searchDisabled ? false : true
    this.itemSelectText = dataset.itemSelectText || ""
    let self = this;

    let swatchSize = dataset.swatchSize;
    if (swatchSize == null) {
      swatchSize = 'small'
    }


    const setPaletteFlag = element.closest('form').querySelector('#palette_setting_recommended_palette')
    if (setPaletteFlag != null) {
      setPaletteFlag.value = false

      this.element.addEventListener('choice', (event) => {
        if (!event.detail.hasOwnProperty("initial")) {
          setPaletteFlag.value = true
          this.element.dispatchEvent(new Event("change"))
        }
      })
    }

    let choices = new Choices(this.element, {
      duplicateItemsAllowed: false,
      searchEnabled: this.searchDisabled,
      itemSelectText: this.itemSelectText,
      position: 'bottom',
      removeItemButton: 'removeItemButton' in dataset ? dataset.removeItemButton : this.multiple,
      callbackOnCreateTemplates: function () {
        return {
          item(
            classNames,
            data,
            removeItemButton,
          ) {
            // Choices doesnt fire an initial choice event when preselected. Do it for them.
            // If this is the first paint, we're currently drawing 'selected' things, fire a 'choice' event for the first thing we paint.
            if (!self.initIntialSelection) {
              self.initIntialSelection = true;
              // create and dispatch the event
              let event = new CustomEvent('choice', {
                detail: {
                  choice: data,
                  initial: "true",
                },
              });
              self.element.dispatchEvent(event);
            }

            let paletteCircles = '';
            let div = null;

            if (data.customProperties) {
              let json = JSON.parse(data.customProperties);
              paletteCircles = json.map((colour) => `<div class="palette-colour-circle ${swatchSize}" style="background-color: ${colour.color};"></div>`).join('');

              div = Object.assign(document.createElement('div'), {
                className: classNames.item,
                innerHTML: `<div class="palette-choice-wrapper">` + data.label + `<div class="palette-colour-circle-wrapper">${paletteCircles}</div></div>`,
              });
            } else {
              div = Object.assign(document.createElement('div'), {
                innerHTML: `<div class="palette-choice-wrapper"> Custom </div>`
              })
            }


            Object.assign(div.dataset, {
              item: '',
              id: data.id,
              value: data.value,
              customProperties: data.customProperties,
            });
            if (data.active) {
              div.setAttribute('aria-selected', 'true');
            }
            if (data.disabled) {
              div.setAttribute('aria-disabled', 'true');
            }
            if (data.placeholder) {
              div.classList.add(classNames.placeholder);
            }
            div.classList.add(data.highlighted ? classNames.highlightedState : classNames.itemSelectable);
            if (removeItemButton) {
              if (data.disabled) {
                div.classList.remove(classNames.itemSelectable);
              }
              div.dataset.deletable = '';
              const REMOVE_ITEM_TEXT = 'Remove item';
              const removeButton = Object.assign(document.createElement('button'), {
                type: 'button',
                className: classNames.button,
                innerHTML: REMOVE_ITEM_TEXT,
              });
              removeButton.setAttribute(
                'aria-label',
                `${REMOVE_ITEM_TEXT}: '${value}'`,
              );
              removeButton.dataset.button = '';
              div.appendChild(removeButton);
            }
            return div;
          },
          choice(
            classNames,
            data,
            selectText,
          ) {

            let paletteCircles = '';
            if (data.customProperties) {
              try {
                let json = JSON.parse(data.customProperties);
                paletteCircles = json.map((colour) => `<div class="palette-colour-circle ${swatchSize}" style="background-color: ${colour.color};"></div>`).join('');
              } catch (e) {
                // ignore
              }
            }

            const div = Object.assign(document.createElement('div'), {
              id: data.elementId,
              innerHTML: `<div class="palette-choice-wrapper">` + data.label + `<div class="palette-colour-circle-wrapper">${paletteCircles}</div></div>`,
              className: `${classNames.item} ${classNames.itemChoice}`,
            });
            if (data.selected) {
              div.classList.add(classNames.selectedState);
            }
            if (data.placeholder) {
              div.classList.add(classNames.placeholder);
            }
            div.setAttribute('role', data.groupId > 0 ? 'treeitem' : 'option');
            Object.assign(div.dataset, {
              choice: '',
              id: data.id,
              value: data.value,
              selectText,
            });
            if (data.disabled) {
              div.classList.add(classNames.itemDisabled);
              div.dataset.choiceDisabled = '';
              div.setAttribute('aria-disabled', 'true');
            } else {
              div.classList.add(classNames.itemSelectable);
              div.dataset.choiceSelectable = '';
            }
            return div;
          },
        };
      },
    });

  }
}
